import { Flex } from "@chakra-ui/react";
import type { EventsCoreDataFragment } from "~/__generated__/graphql";

import Footer from "../landing/v2/footer";
import Navbar from "../navbar";
import Events from "./events";

export type EventProps = {
  data: {
    events: EventsCoreDataFragment[];
  };
};

const EventPage = () => {
  return (
    <Flex minHeight="100vh" direction="column" minWidth={"375px"} mx="auto" fontFamily="Inter">
      <Navbar />
      <Events />
      <Footer cta />
    </Flex>
  );
};

export default EventPage;
